import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, viewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ProprieteAffichee } from "src/app/bo/proprieteAffichee";
import { VibrationData } from "src/app/bo/vibrationsForChart/vibration-data";
import { VibrationsRecordService } from "src/app/services/vibrations-record.service";
import { Chart } from 'src/app/utils/chart-config';
import { VibrationRecords } from "src/app/bo/vibrationsForChart/vibration-records";
import { HttpEvent, HttpEventType } from "@angular/common/http";
import { VibrationChartChannel } from "src/app/bo/vibrationsForChart/vibration-chart-channel";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FonctionsService } from "src/app/services/fonctions-partagees.service";
import { ControlPoint } from "src/app/bo/controlPoint";

@Component({
    selector: 'app-record-modal',
    templateUrl: './record-modal.component.html',
    styleUrls: ['./record-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
  })
  export class RecordModalComponent {
    readonly fileInput = viewChild<ElementRef>('fileInput');
    constructor(
      public dialogRef: MatDialogRef<RecordModalComponent>,
      private readonly recordSevice: VibrationsRecordService,
      private readonly el: ElementRef,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private readonly cdRef: ChangeDetectorRef,
      private readonly fb: FormBuilder,
      private readonly fonctionsService: FonctionsService
    ) {
      this.manualForm = this.fb.group({
        controlPointId: [null, [Validators.required, Validators.min(1)]],
        distance:       [null, [Validators.required, Validators.min(0)]],
        overpressure:   [null, [Validators.required, Validators.min(0)]],
        pic:            [null, [Validators.required, Validators.min(0)]],
      });
    }

    activeTab: 'manual' | 'upload' = 'manual';

    manualForm: FormGroup;
    isManualSubmitting = false;
    get controlPoints(): ControlPoint[] {
      return this.data?.controlPoints ?? [];
    }
    chartInstances: Map<string, Chart> = new Map();
    files: File[] = [];
    siteId: number;
    minMax: number[] = [];
    isRemoteOrLocal = false;
    indexSelected: number;
    fileTempSended = '';
    vibrationsChartLocal: VibrationData[] = [];
    vibrationsChart: VibrationData[] = [];
    tabDonneesVibrationNewModel: VibrationData[] = [];
    vibrationsNewModelSelected: VibrationData;
    fileName: string
    allRecords: VibrationData[] = [];
    proprietesAffichees: ProprieteAffichee[];
    barValue = '0%';
    isLoading = false;
    
    confirm() {
      this.allRecords.forEach((record, index) => {
        record.blastId = this.data.blastId;
      })
        let data: VibrationRecords = {
          information: {
            currentURL: window.location.href,
            regionName: this.data.regionName,
            siteName: this.data.siteName,
            controlPointName: this.data.controlPointName,
          },
          
          vibrationRecords: this.allRecords

        }
        this.recordSevice.SaveRecords(this.data.siteId, data).subscribe((response) => {
          this.dialogRef.close(true);
        })
      }
    
    
      onDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
      }
  onFileDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const files = event.dataTransfer?.files;
    if (files) {
      this.handleFiles(files);
    }
  }
  onFileInputChange(event: Event) {
    this.isLoading = true;
    const input = event.target as HTMLInputElement;
    if (input && input.files) {
      this.handleFiles(input.files);
    }
  }
  
  private handleFiles(files: FileList) {
    Array.from(files).forEach(file => {
      if (this.isFileAllowed(file.name)) {
        this.files.push(file);
      }

      setTimeout(() => {
        if (this.files.length > 0) {
          this.managerFile();
        }
      }, 10 * files.length);

    });
  }
  private managerFile() {
    
    this.vibrationsChartLocal = [];
    let formData = new FormData();
    for (let i = 0; i < this.files.length; i++) {
      formData.append('files', this.files[i], this.files[i].name);
    }
    this.recordSevice.UploadFilenRecords(this.data.siteId, formData).subscribe({
      next: (event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.Sent:
            break;

          case HttpEventType.ResponseHeader:
            this.isRemoteOrLocal = true;
            break;
            case HttpEventType.UploadProgress:
              this.barValue = Math.round(event.loaded / event.total * 100).toString() + '%';
              break;
          case HttpEventType.Response:
            let vib = event.body.data;
            this.allRecords = [];
            if (vib != null) {
              vib.forEach((v, i) => {
                this.chartListUpdate(v, i);
              })
            }
            this.fileTempSended = 'filesSended';
            setTimeout(() => {
              this.cdRef.markForCheck();
            }, 500);
        }
      },
      error: (error) => {
        setTimeout(() => {
        }, 500);
      },
      complete: () => {
      }
    });
  }
  public submitManualRecord(): void {
    if (this.manualForm.invalid) {
      this.manualForm.markAllAsTouched();
      this.cdRef.markForCheck();
      return;
    }
    this.isManualSubmitting = true;
    this.cdRef.markForCheck();

    const { controlPointId, distance, overpressure, pic } = this.manualForm.value;
    const payload = {
      controlPointId: +controlPointId,
      distance: +distance,
      overpressure: +overpressure,
      pic: +pic,
      siteId: this.data.siteId,
      blastId: this.data.blastId,
    };

    this.recordSevice.saveManualRecord(this.data.siteId, payload).subscribe({
      next: () => {
        this.fonctionsService.launch_toast(true);
        this.dialogRef.close(true);
      },
      error: () => {
        this.isManualSubmitting = false;
        this.fonctionsService.launch_toast(false);
        this.cdRef.markForCheck();
      },
    });
  }

  public closeDialog(): void {
    this.dialogRef.close(false);
  }  private chartListUpdate(vib: VibrationData, index: number) {
    this.vibrationsChart = this.vibrationsChartLocal;
    this.vibrationsNewModelSelected = vib;
    this.vibrationsNewModelSelected.eventId = this.data.eventId;
    this.vibrationsNewModelSelected.controlPointId = this.data.controlPointId;
    this.allRecords.push(this.vibrationsNewModelSelected);
    this.indexSelected = 0;
    setTimeout(() => {
      this.drawingVibrations(index);
    }, 1000);

    setTimeout(() => {
      this.cdRef.markForCheck();
      this.cdRef.detectChanges();
    }, 1000);
  }

  private checkChannelData(data: VibrationChartChannel): boolean {
    let dataNullNumber = 0;
    data.timeSpectrum.values.forEach((v, i, a) => {
      if (v === 0) {
        dataNullNumber++;
      }
    });
    return dataNullNumber === data.timeSpectrum.values.length;
  }

  private isFileAllowed(fileName: string) {
    let isFileAllowed = false;
    const allowedFiles = ['.csv', '.sis', ''];
    const regex = /(?:\.([^.]+))?$/;
    const extension = regex.exec(fileName);
    if (undefined !== extension && null !== extension) {
      for (const ext of allowedFiles) {
        if (ext === extension[0]) {
          isFileAllowed = true;
        }
      }
    }
    return isFileAllowed;
  }

  private drawingVibrations(j: number) {
    if (this.allRecords.length === 0) return;
    let minMax = this.findMinMax(this.allRecords[j]);
    this.allRecords[j].signalDataEntity?.signalData?.channels.forEach((value, index, array) => {
      if (!this.checkChannelData(value)) {
        this.drawingChannel(index, this.allRecords[j], minMax, j);
      }
    })

  }

  private findMinMax(vibration: VibrationData): number[] {
    let minMax = [0, 0, 0, 0];
    vibration?.signalDataEntity?.signalData?.channels.forEach((value, index, array) => {
      if (index < vibration?.signalDataEntity?.signalData?.channels.length - 1) {
        if (value.timeSpectrum.ppvMin < minMax[0]) minMax[0] = value.timeSpectrum.ppvMin;
        if (value.timeSpectrum.ppvMax > minMax[1]) minMax[1] = value.timeSpectrum.ppvMax;
      } else {
        minMax[2] = value.timeSpectrum.ppvMin;
        minMax[3] = value.timeSpectrum.ppvMax;
      }
    })
    return minMax;
  }

  private drawingChannel(index: number, vibrations: VibrationData, minMax: number[], indexRecord: number) {
    let canvas = <HTMLCanvasElement>this.el.nativeElement.querySelector('#canvas-' + indexRecord + '-' + index);
    let ctx = canvas.getContext('2d');
    const chartKey = `${indexRecord}-${index}`;
    if (this.chartInstances.has(chartKey)) {
      this.chartInstances.get(chartKey)?.destroy();
      this.chartInstances.delete(chartKey);
  }

    let array_for_label: number[] = [];
    vibrations?.signalDataEntity?.signalData?.channels[index].timeSpectrum.values.forEach((value, index) => {
      array_for_label[index] = index;
    });
    let chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: array_for_label,
        datasets: [{
          label: '',
          data: vibrations?.signalDataEntity?.signalData?.channels[index].timeSpectrum.values,
          fill: false,
          tension: 0.1,
          borderWidth: 1,
          borderColor: 'rgb(153,0,77)',
          backgroundColor: 'white',
        }],
      },
      options: {
        elements: {
          point: {
            radius: 0
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          x: {
            grid: {
              tickLength: 3,
            },
            ticks: {
              maxTicksLimit: vibrations?.signalDataEntity?.signalData?.channels.length,
              callback: function (value, index, ticks) {
                return Math.round(index / 2048) + 's';
              },
              padding: 0
            },
            display: false,
          },
          y: {
            min: (index < vibrations?.signalDataEntity?.signalData?.channels.length - 1) ? minMax[0] : minMax[2],
            max: (index < vibrations?.signalDataEntity?.signalData?.channels.length - 1) ? minMax[1] : minMax[3],
            ticks: {
              stepSize: 0.5,
            },
            grid: {
              tickLength: 3,
            }
          }
        }
      }
    });
    this.chartInstances.set(chartKey, chart);
  }
  sortColumn = '';
  sortOrder = true;

  sortTable(column: string): void {

    if (this.sortColumn === column) {
      this.sortOrder = !this.sortOrder;
    } else {
      this.sortColumn = column;
      this.sortOrder = true;
    }
  }

  findMaxAbsValue(min: number, max: number) {
    return Math.abs(max) > Math.abs(min) ? max : Math.abs(min);
  }
}
